import './LinkBtn.scss'
import {Link} from "react-router-dom";
import {getUrlWithLocal} from "../../utils/getUrlWithLocal";
import {AboutArrIcon} from "../../assets/images";
import React from "react";

export default function LinkBtn({link,staticTexts}){

    return <Link to={getUrlWithLocal(link)} className={'link-btn'}>
        {staticTexts?.moreBtn_text} <AboutArrIcon/>
    </Link>
}